import { type StudioDay, studioStarts } from '@repo/core/studio-calendar'
import type { CSSProperties } from 'react'

/**
 * Words and arithmetic the studio page and its dates dialog share.
 */

export const DAY_SHORT = ['nd', 'pn', 'wt', 'śr', 'czw', 'pt', 'sob']
export const DAY_LONG = [
  'niedziela',
  'poniedziałek',
  'wtorek',
  'środa',
  'czwartek',
  'piątek',
  'sobota',
]
export const MONTH = [
  'styczeń',
  'luty',
  'marzec',
  'kwiecień',
  'maj',
  'czerwiec',
  'lipiec',
  'sierpień',
  'wrzesień',
  'październik',
  'listopad',
  'grudzień',
]
export const MONTH_OF = [
  'stycznia',
  'lutego',
  'marca',
  'kwietnia',
  'maja',
  'czerwca',
  'lipca',
  'sierpnia',
  'września',
  'października',
  'listopada',
  'grudnia',
]
export const MONTH_SHORT = [
  'sty',
  'lut',
  'mar',
  'kwi',
  'maj',
  'cze',
  'lip',
  'sie',
  'wrz',
  'paź',
  'lis',
  'gru',
]

/** Start times free on one day, whole hours, the last one leaving room for the block. */
export function startsFor(
  calendar: readonly StudioDay[],
  dayISO: string | null,
  hours: number,
): string[] {
  if (!dayISO) return []
  return studioStarts(
    calendar.find((day) => day.date === dayISO),
    hours,
  )
}

/**
 * How many columns a row of choices takes, so it always fills the panel.
 *
 * Owner: *„wszystkie godziny dajmy w 2 liniach, jeśli jest ich dużo, a jeśli
 * mało to w jednej"* and *„rzeczy typu ile godzin, dzień i godzina zawsze
 * rozciągają się na całą szerokość"*. Up to four sit in one row; past that
 * they split into two rows, the last one stretching to the edge too.
 *
 * Capped at `max` columns, because starts come on every whole hour: a
 * Saturday with a one-hour block has thirteen of them, and thirteen in two
 * rows was seven pills of 50px each — *„godziny rozpoczęcia są zbyt małe i się
 * zlewają"*. Past the cap the rows simply grow in number; a time has to stay
 * readable and tappable before it stays on two lines.
 */
export function rowColumns(count: number, max: number): number {
  if (count <= Math.min(4, max)) return Math.max(1, count)
  return Math.min(max, Math.ceil(count / 2))
}

/** A button's share of a row that has `columns` of them, gaps included. */
export function rowBasis(columns: number, gapRem: number): CSSProperties {
  return { flexBasis: `calc((100% - ${(columns - 1) * gapRem}rem) / ${columns})` }
}
